import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import EventEmitter, {
  SHOW_POPUP_CONFIRMATION,
} from '../../../../../helpers/EventEmitter'
import { handleExport } from '../../../../../helpers/export'
import service from './service'

export const getDetailOrderThunk = createAsyncThunk(
  'userManagement/subscriptionPayment/orderManagement/getDetailOrderThunk',
  async (params, { rejectWithValue }) => {
    try {
      const res = await service.getDetailOrder(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const downloadReportThunk = createAsyncThunk(
  'userManagement/subscriptionPayment/orderManagement/downloadReportThunk',
  async (params) => {
    try {
      const res = await service.downloadReport(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)

export const postCancelOrder = createAsyncThunk(
  'userManagement/postCancelOrder',
  async (params, { rejectWithValue }) => {
    try {
      const response = await service.postCancelOrder(params)

      if (response?.success) {
        EventEmitter.dispatch(
          SHOW_POPUP_CONFIRMATION,
          'userManagement.orderManagement.orderDetail.CONFIRM_CANCEL_REQUEST_MESS',
        )

        return response
      }
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)
